/**
 * Typed Redux hooks for the web-app.
 *
 * Import `useAppDispatch` and `useAppSelector` from here instead of the
 * plain `react-redux` versions — they are pre-typed against `AppDispatch`
 * and `RootState` so you never have to annotate the type manually.
 *
 * Usage:
 *   const dispatch = useAppDispatch();
 *   const user = useAppSelector((state) => state.auth.user);
 */
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './store';

/** Pre-typed `useDispatch` — returns `AppDispatch` (RTK-aware). */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

/** Pre-typed `useSelector` — state is typed as `RootState`. */
export const useAppSelector = useSelector.withTypes<RootState>();
